import { Stack, useTheme } from "@mui/material";
import { ConstantContext } from "components/context/ConstantProvider";
import Highlight from "components/ui/atoms/Highlight";
import Layout from "components/ui/molecules/Layout";
import { CommitteeMinutePrintListCondensedPreview } from "models/committee/CommitteeMinutePrintListCondensed";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const CommitteeMinute = ({}) => {
  const { deal_flow_id } = useParams();

  const theme = useTheme();
  const { dealFlows } = useContext(ConstantContext);
  const [dealFlow, setDealFlow] = useState(undefined);

  useEffect(() => {
    if (dealFlows)
      dealFlows.some((dealFlow) => {
        if (dealFlow.id == deal_flow_id) {
          setDealFlow(dealFlow);
          return true;
        }
      });
  }, [deal_flow_id, dealFlows]);

  if (!dealFlow) {
    return <>Error</>;
  }

  const validateCommittee = () => {
    return mutateValidateDealCommitteeAsync(dealFlow.id).catch((error) => {
      displayError(error);
    });
  };

  return (
    <Layout container hideBreadcrumbs>
      <Layout title variant="component">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          width={1}
        >
          <Highlight color={theme.palette_custom.yellow}>
            Preview of committee minutes for {dealFlow.name}
          </Highlight>
        </Stack>
      </Layout>
      <Layout content>
        <CommitteeMinutePrintListCondensedPreview dealFlowId={dealFlow.id} />
      </Layout>
    </Layout>
  );
};

export default CommitteeMinute;
